import { SVGProps } from 'react';

const VoucherIcon = ({
  className,
  fill,
  height = 15,
  width = 15,
  style
}: SVGProps<SVGSVGElement>) => (
  <span className={className} style={{ ...style, height, width }}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
      <path
        d="M363 4465 c-175 -47 -317 -195 -353 -368 -7 -35 -10 -203 -8 -504 3
        -438 4 -452 24 -479 39 -52 67 -66 157 -75 140 -14 237 -60 325 -153 173 -182
        173 -470 0 -652 -88 -93 -185 -139 -325 -153 -90 -9 -118 -23 -157 -75 -20
        -27 -21 -41 -24 -479 -2 -301 1 -469 8 -504 37 -175 179 -322 357 -368 87 -23
        4299 -23 4386 0 178 46 320 193 357 368 7 35 10 203 8 504 -3 438 -4 452 -24
        479 -38 52 -67 66 -153 75 -136 13 -216 48 -309 133 -201 187 -201 505 0 692
        93 85 173 120 309 133 86 9 115 23 153 75 20 27 21 41 24 479 2 301 -1 469 -8
        504 -37 175 -179 322 -357 368 -84 22 -4309 21 -4390 0z m4363 -331 c15 -11
        37 -33 48 -48 20 -26 21 -42 24 -387 3 -339 2 -359 -15 -359 -38 -1 -192 -68
        -258 -112 -187 -124 -309 -307 -351 -526 -71 -371 146 -752 506 -889 47 -18
        93 -32 103 -33 17 0 18 -20 15 -359 -3 -345 -4 -361 -24 -387 -11 -15 -33 -37
        -48 -48 l-27 -21 -2139 0 -2139 0 -27 21 c-15 11 -37 33 -48 48 -20 26 -21 42
        -24 385 l-3 357 44 11 c134 36 259 108 356 204 189 188 275 457 227 711 -59
        307 -285 551 -583 631 l-43 11 0 342 c0 355 2 378 43 423 49 53 -80 50 2209
        48 l2127 -2 27 -21z"
      />
      <path
        d="M2871 3846 c-368 -979 -931 -2484 -933 -2495 -4 -16 281 -127 292
        -114 4 4 219 573 478 1263 259 690 473 1262 476 1270 5 12 -27 28 -144 71
        l-150 56 -19 -51z"
      />
      <path
        d="M1725 3459 c-193 -28 -364 -203 -395 -403 -35 -228 110 -458 331
        -527 72 -22 191 -25 264 -5 209 56 355 245 355 460 -1 298 -258 518 -555 475z
        m160 -338 c16 -9 40 -33 53 -52 20 -28 23 -44 20 -90 -7 -94 -66 -149 -161
        -149 -58 0 -105 32 -135 92 -32 63 -24 115 25 169 55 60 127 71 198 30z"
      />
      <path
        d="M3338 2459 c-111 -26 -250 -135 -301 -235 -46 -90 -60 -158 -55 -260
        4 -80 10 -103 41 -168 118 -250 400 -350 645 -230 184 90 294 299 262 498 -29
        180 -160 334 -331 387 -65 20 -193 24 -261 8z m203 -332 c49 -32 83 -105 74
        -158 -15 -88 -111 -151 -196 -129 -101 27 -148 131 -103 227 38 79 151 109
        225 60z"
      />
      </g>
    </svg>
  </span>
);

export default VoucherIcon;
